import { defineMessages } from 'react-intl';

export const scope = 'app.components.SelectionTargetGate';

export const messages = defineMessages({
  notFound: {
    id: `${scope}.notFound`,
    defaultMessage: 'This link points to something that no longer exists, so your current selection is still showing.',
  },
  conflict: {
    id: `${scope}.conflict`,
    defaultMessage: "This link mixes items from different assessments or associations, so it couldn't be opened. Your current selection is still showing.",
  },
  missingPermission: {
    id: `${scope}.missingPermission`,
    defaultMessage: "You don't have permission to open what this link points to, so your current selection is still showing.",
  },
  failed: {
    id: `${scope}.failed`,
    defaultMessage: "We couldn't open what this link points to, so your current selection is still showing.",
  },
  offline: {
    id: `${scope}.offline`,
    defaultMessage: "You're offline, so this link couldn't switch your selection. Your current selection is still showing.",
  },
  slow: {
    id: `${scope}.slow`,
    defaultMessage: 'This link is taking a while, so the page opened with your current selection. It will switch once the link finishes.',
  },
  skipped: {
    id: `${scope}.skipped`,
    defaultMessage: "Some items in this link no longer exist or weren't valid, so they were skipped.",
  },
});
